import { ActionIcon, Button, Flex } from "@mantine/core";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";

export default function PaginationBar({currentPage, pageCount, handleOnClick}) { 
    return (
        <Flex p="lg" justify="center" align="center" gap="sm" direction="row">
            <ActionIcon variant="filled" disabled={currentPage === 0} size="md" onClick={() => handleOnClick(currentPage - 1)}>
                <MdArrowBackIosNew size="1rem" />
                </ActionIcon>
                <Button disabled={currentPage === 0} compact size="md" color="gray" onClick={() => handleOnClick(0)}>1</Button>
                { pageCount > 1 && currentPage > 2 ? "..." : null }
                { currentPage > 1 ? <Button compact size="md" color="gray" onClick={() => handleOnClick(currentPage - 1)}>{ currentPage }</Button> : null }
                { (currentPage > 0 && currentPage < pageCount - 1) ? <Button disabled compact size="md" color="gray">{ currentPage + 1}</Button> : null }
                { (pageCount > 1 && currentPage < pageCount - 2) ? <Button compact size="md" color="gray" onClick={() => handleOnClick(currentPage + 1)}>{ currentPage + 2}</Button> : null }
                { pageCount > 1 && currentPage < pageCount - 3 ? "..." : null }
                { pageCount > 1 ? <Button disabled={currentPage >= pageCount - 1} compact size="md" color="gray" onClick={() => handleOnClick(pageCount - 1)}>{pageCount}</Button> : null }
                <ActionIcon variant="filled" disabled={currentPage >= pageCount - 1} size="md" onClick={() => handleOnClick(currentPage + 1)}>
                <MdArrowForwardIos size="1rem" />
            </ActionIcon>
        </Flex>
    )
}
